import type { ActiviteitTemplate } from '../../templates/types/ActiviteitTemplate'

export function getWeeksBeforeStartUitvoering(
  combi: string | undefined,
  templates: ActiviteitTemplate[],
): number {
  if (!combi || !templates || templates.length === 0) {
    return 0
  }

  const template = templates.find(
    (t) => t.combi === combi && t.type === 'Extra werkvoorbereiding',
  )

  return template?.herplanDiff ?? 0
}
